import firebase from 'firebase/app';
import 'firebase/auth';

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_NUGU_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_NUGU_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_NUGU_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_NUGU_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_NUGU_FIREBASE_STORAGE_BUCKET,
  messagingSenderId:
    process.env.REACT_APP_NUGU_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_NUGU_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_NUGU_FIREBASE_MEASUREMENT_ID,
});

export const auth = app.auth();
// export const db = firebase.firestore();
export default app;